import React from "react";

import { Theme } from "../../../theme/restyle/theme";
import { ButtonVariant } from "./Button";

/**
 * Get the appropriate icon color for a button variant
 */
export const getIconColor = (
  variant: ButtonVariant,
  isDisabled?: boolean
): keyof Theme["colors"] => {
  if (isDisabled) {
    return "button-disabled-icon";
  }

  switch (variant) {
    case "main":
      return "button-main-icon";
    case "secondary":
      return "button-alt-icon";
    case "white":
      return "button-white-icon";
    case "danger":
      return "button-danger-icon";
    case "ghost":
      return "button-ghost-icon";
    case "outline":
      return "button-ghost-icon";
    default:
      return "button-alt-icon";
  }
};

/**
 * Assign icon styles to left and right icons based on button variant
 */
export const assignIconStyles = (
  leftIcon: React.ReactNode,
  rightIcon: React.ReactNode,
  variant: ButtonVariant,
  isDisabled?: boolean
) => {
  const iconColor = getIconColor(variant, isDisabled);

  if (rightIcon && React.isValidElement(rightIcon)) {
    rightIcon = React.Children.map(
      rightIcon,
      (child: React.JSX.Element, index: number) => {
        return React.cloneElement(child, {
          key: `button-end-icon-${index}`,
          color: iconColor,
          ...child.props,
        });
      }
    );
  }

  if (leftIcon && React.isValidElement(leftIcon)) {
    leftIcon = React.Children.map(
      leftIcon,
      (child: React.JSX.Element, index: number) => {
        return React.cloneElement(child, {
          key: `button-start-icon-${index}`,
          color: iconColor,
          ...child.props,
        });
      }
    );
  }

  return { leftIcon, rightIcon };
};
